import Command from "@ckeditor/ckeditor5-core/src/command";

import { CkeditorConstants } from '../../src/utils';

const { htmlAttributes: { ID }, helperAttributes: { NUMBERED_CITATION } } = CkeditorConstants;

export default class CitationsReOrderCommand extends Command {
  execute({ value }) {
    const editor = this.editor;
    let reOrderFirstAndSubsRef = [];

    reOrderFirstAndSubsRef = value.data.filter((item) => (item.isDeleteDialogRequired === false));
    if (this.editor.commands.get('trackChanges').value && this.editor.plugins.get('TrackChanges').isEnabled) {
      // Checks if current selection already has trackchange marker
      const range = editor.model.document.selection.getFirstRange();
      const markers = [...editor.model.markers.getMarkersIntersectingRange(range)]
      const isInsertion = (markers.length && markers[0].name) ? markers[0].name.includes('insertion') : null;
      //Marks current selection as 'Deletion'
      editor.plugins.get('TrackChangesEditing').markDeletion(range);
    }
    else {
      let numberedcitationInSelection = [];
      numberedcitationInSelection = [...editor.model.document.selection.getRanges()]
        .flatMap(range => [...range.getWalker()])
        .filter(itemInSelection => itemInSelection.item.name === 'numberedcitation');

      numberedcitationInSelection.forEach((numberedcitation) => {
        editor.model.change(writer => {
          writer.remove(numberedcitation.item)
        });
      });
    }

    editor.model.deleteContent(
      editor.model.document.selection
    );

    const data = {
      citationsPanelReOrderData: value.data,
    };
    this.editor.fire(CkeditorConstants.event.CITATION_PANEL_REORDER, data);
    this.editor.commands.get('save').isEnabled = true;
    this.editor.commands.get('save').hasUnsavedChanges =
      true;
  }
}